import { createUseStyles } from 'react-jss'
import { colors } from 'components/common'

const useIconStyles = createUseStyles({
  iconWrapper: {
    margin: '0 0.25rem',
    padding: '0.5rem',
    transition: 'none',

    '&.icon.icon-xs': {
      padding: '4px'
    },
    '&.badge': {
      backgroundColor: '#fff',
      border: '1px solid #aaa',
      color: '#aaa',
      borderRadius: 4
    },
    '&.rounded': {
      backgroundColor: colors.gray200,
      borderRadius: '100%'
    },
    '&.disabled': {
      opacity: 0.4,
      pointerEvents: 'none'
    },
    '&.clickable': {
      cursor: 'pointer',

      '&.color-primary:hover': {
        backgroundColor: colors.theme500,
        color: '#fff'
      },
      '&.color-warning:hover': {
        backgroundColor: colors.orange500,
        color: '#fff'
      },
      '&.color-danger:hover': {
        backgroundColor: colors.red500,
        color: '#fff'
      }
    }
  }
})

export { useIconStyles }
